import * as actions from '../actions'

const defaultState = []

export default function globalConfig(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_GLOBAL_CONFIG:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.CLEAN_ALL:
        case actions.APP_SELECT:
            return defaultState

        default:
            return state
    }
}
